import { useCurrentUser } from "../actions/CurrentUserActions";
import {
  ACCEPTED_AUDIO_CONTENT_TYPES,
  ACCEPTED_CONTENT_TYPES,
  NATIVELY_SUPPORTED_AUDIO_CONTENT_TYPES,
} from "../constants/AcceptedFiles";

export const useStudioAcceptedContentTypes = (): string[] => {
  const { currentUser } = useCurrentUser();
  const hasStudioVideoUploadEnabled = Boolean(
    currentUser?.studioVideoUploadEnabled
  );
  const hasStudioConvertedAudioUploadEnabled = Boolean(
    currentUser?.studioConvertedAudioUploadEnabled
  );

  if (hasStudioVideoUploadEnabled) {
    return ACCEPTED_CONTENT_TYPES;
  }

  if (hasStudioConvertedAudioUploadEnabled) {
    return ACCEPTED_AUDIO_CONTENT_TYPES;
  }

  return NATIVELY_SUPPORTED_AUDIO_CONTENT_TYPES;
};
